import React from 'react'
import Home_Top_Destination from '../Components/Home_Top_Destination'
import Home from "../Components/Home_Destination"

export default function Destination() {
  return (
    <div>
      <Home_Top_Destination />
      <Home />
  
    </div>
  )
}
